import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { HERO_SLIDES } from "../data/watches";
import { IconChevronLeft, IconChevronRight } from "./Icons";

const HeroSection = () => {
  const [heroIndex, setHeroIndex] = useState(0);
  const heroTimer = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    heroTimer.current = setInterval(
      () => setHeroIndex((i) => (i + 1) % HERO_SLIDES.length),
      5000,
    );
    return () => clearInterval(heroTimer.current);
  }, []);

  const goHero = (dir) => {
    clearInterval(heroTimer.current);
    setHeroIndex((i) => (i + dir + HERO_SLIDES.length) % HERO_SLIDES.length);
    heroTimer.current = setInterval(
      () => setHeroIndex((i) => (i + 1) % HERO_SLIDES.length),
      5000,
    );
  };

  const handleCta = (index) => {
    if (index === 0) navigate("/watches");
    else if (index === 1) {
      const el = document.getElementById("contact");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      const el = document.getElementById("contact");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero">
      {HERO_SLIDES.map((slide, i) => (
        <div
          key={i}
          className="hero-slide"
          style={{
            opacity: i === heroIndex ? 1 : 0,
            zIndex: i === heroIndex ? 1 : 0,
          }}
        >
          <img className="hero-bg" src={slide.img} alt={slide.title} />
          <div className="hero-overlay" />
          <svg
            className="hero-deco"
            width="300"
            height="300"
            viewBox="0 0 300 300"
          >
            <circle
              cx="150"
              cy="150"
              r="140"
              fill="none"
              stroke="#c9a96e"
              strokeWidth="0.5"
            />
            <circle
              cx="150"
              cy="150"
              r="120"
              fill="none"
              stroke="#c9a96e"
              strokeWidth="0.3"
            />
            <circle cx="150" cy="150" r="4" fill="#c9a96e" opacity="0.5" />
            {[...Array(12)].map((_, j) => {
              const angle = ((j * 30 - 90) * Math.PI) / 180;
              const x1 = 150 + 130 * Math.cos(angle);
              const y1 = 150 + 130 * Math.sin(angle);
              const x2 = 150 + 140 * Math.cos(angle);
              const y2 = 150 + 140 * Math.sin(angle);
              return (
                <line
                  key={j}
                  x1={x1}
                  y1={y1}
                  x2={x2}
                  y2={y2}
                  stroke="#c9a96e"
                  strokeWidth="1"
                  opacity="0.4"
                />
              );
            })}
            <line
              x1="150"
              y1="150"
              x2="150"
              y2="70"
              stroke="#c9a96e"
              strokeWidth="2"
              opacity="0.3"
            />
            <line
              x1="150"
              y1="150"
              x2="200"
              y2="100"
              stroke="#c9a96e"
              strokeWidth="1"
              opacity="0.3"
            />
          </svg>
          {i === heroIndex && (
            <div className="hero-content">
              <div
                className="hero-label fade-up"
                style={{ animationDelay: "0.2s" }}
              >
                Legacy Timepieces
              </div>
              <h1
                className="hero-title fade-up"
                style={{ animationDelay: "0.4s" }}
              >
                {slide.title}
              </h1>
              <p
                className="hero-subtitle fade-up"
                style={{ animationDelay: "0.6s" }}
              >
                {slide.subtitle}
              </p>
              <button
                className="hero-cta fade-up"
                style={{ animationDelay: "0.8s" }}
                onClick={() => handleCta(i)}
              >
                {slide.cta}
              </button>
            </div>
          )}
        </div>
      ))}
      <button className="hero-nav prev" onClick={() => goHero(-1)}>
        <IconChevronLeft />
      </button>
      <button className="hero-nav next" onClick={() => goHero(1)}>
        <IconChevronRight />
      </button>
      <div className="hero-dots">
        {HERO_SLIDES.map((_, i) => (
          <button
            key={i}
            className={`hero-dot ${i === heroIndex ? "active" : ""}`}
            onClick={() => {
              clearInterval(heroTimer.current);
              setHeroIndex(i);
            }}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
